import React from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import { ROLES_LABELS } from '../../constants/general';

const useStyles = makeStyles(() => ({
  admin: {
    backgroundColor: '#FFF8E1',
    color: '#F57C00',
  },
  default: {
    backgroundColor: '#F5F5F5',
    color: '#616161',
  },
  leadTech: {
    backgroundColor: '#F3E5F5',
    color: '#7B1FA2',
  },
  radiologist: {
    backgroundColor: '#E3F2FD',
    color: '#1976D2',
  },
  roleCell: {
    borderRadius: '4px',
    display: 'inline-block',
    padding: '4px 8px',
    textAlign: 'center',
  },
  technologist: {
    backgroundColor: '#E8F5E9',
    color: '#388E3C',
  },
}));

const getRoleClass = (role, classes) => {
  switch (role) {
    case 'ADMIN':
      return classes.admin;
    case 'LEAD-TECH':
      return classes.leadTech;
    case 'RADIOLOGIST':
      return classes.radiologist;
    case 'TECHNOLOGIST':
      return classes.technologist;
    default:
      return classes.default;
  }
};

export default ({ value }) => {
  const classes = useStyles();
  const roleClass = getRoleClass(value, classes);

  return (
    <Typography variant="body2" component="span" className={`${classes.roleCell} ${roleClass}`}>
      {ROLES_LABELS[value]}
    </Typography>
  );
};
